export function getItem(key: string) {
    if (!key) {
        return null;
    }
    return (
        decodeURIComponent(
            document.cookie.replace(
                new RegExp(
                    `(?:(?:^|.*;)\\s*${encodeURIComponent(key).replace(
                        /[-.+*]/g,
                        '\\$&',
                    )}\\s*\\=\\s*([^;]*).*$)|^.*$`,
                ),
                '$1',
            ),
        ) || null
    );
}

export function setItem(
    key: string,
    value: string,
    maxAge: number,
    path?: string,
    domain?: string,
    secure?: boolean,
) {
    if (!key || /^(?:expires|max-age|path|domain|secure)$/i.test(key)) {
        return false;
    }
    let sExpires = '';
    if (maxAge) {
        sExpires = `; max-age=${maxAge}`;
    }
    document.cookie = `${encodeURIComponent(key)}=${encodeURIComponent(
        value,
    )}${sExpires}${domain ? `; domain=${domain}` : ''}${
        path ? `; path=${path}` : ''
    }${secure ? '; secure' : ''}`;
    return true;
}

export function removeItem(key: string, path?: string, domain?: string) {
    if (!hasItem(key)) {
        return false;
    }
    document.cookie = `${encodeURIComponent(
        key,
    )}=; expires=Thu, 01 Jan 1970 00:00:00 GMT${
        domain ? `; domain=${domain}` : ''
    }${path ? `; path=${path}` : ''}`;
    return true;
}

export function hasItem(key: string) {
    if (!key) {
        return false;
    }
    return new RegExp(
        `(?:^|;\\s*)${encodeURIComponent(key).replace(
            /[-.+*]/g,
            '\\$&',
        )}\\s*\\=`,
    ).test(document.cookie);
}
